import type { App, } from "vue"
import type { RouteRecordRaw, } from "vue-router"
import { cloneDeep, } from "lodash-es"
import { createRouter, createWebHistory, } from "vue-router"
import { IMPORT_META_ENV, } from "@/constants"
import { useI18nTitle, } from "@/hooks/useI18nTitle.ts"
import {
  GORGIAS_CUSTOMER,
  GORGIAS_ORDER,
  GORGIAS_SHOP,
  GORGIAS_TOKEN,
  //  TOKEN_NAME,
  useToken,
} from "@/hooks/useToken.ts"
// import { useRouteStore, } from "@/store/Route"
// import { useUserStore, } from "@/store/UserInfo"
import { SimpleLayout, } from "@/utils/routerHelper.ts"
// import {
//   checkVersionFn,
// } from "./helper.ts"

export const constantRouterMap: CustomRouteRecordRaw[] = [
  // {
  //   path: "/",
  //   component: Layout,
  //   redirect: "/home",
  //   name: "Root",
  //   meta: {
  //     title: "Home",
  //     activeMenu: "/home",
  //   },
  //   children: [
  //     {
  //       path: "/home",
  //       component: () => import("@/views/workbench/index.vue"),
  //       name: "Home",
  //       meta: {
  //         affix: true,
  //         icon: "cil:house",
  //         title: "Home",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/",
    component: SimpleLayout,
    redirect: "/order",
    name: "Root",
    meta: {
      title: "Order",
      activeMenu: "/order",
    },
    children: [
      {
        path: "/order",
        component: () => import("@/views/order/index.vue"),
        name: "Order",
        meta: {
          // affix: true,
          // icon: "cil:house",
          title: "Order",
        },
      },
    ],
  },
  {
    path: "/user",
    component: SimpleLayout,
    name: "User",
    redirect: "/login",
    meta: {
      title: "User",
    },
    children: [
      {
        path: "login",
        component: () => import("@/views/user/login.vue"),
        name: "Login",
        meta: {
          title: "Login",
        },
      },
      {
        path: "change-password",
        component: () => import("@/views/user/change-password.vue"),
        name: "ChangePassword",
        meta: {
          title: "Change Password",
        },
      },
    ],
  },
  // {
  //   path: "/redirect",
  //   component: Layout,
  //   name: "RedirectIndex",
  //   children: [
  //     {
  //       path: "/redirect/:path(.*)",
  //       name: "Redirect",
  //       component: () => import("@/views/redirect/redirect.vue"),
  //       meta: {},
  //     },
  //   ],
  //   meta: {
  //     hidden: true,
  //     noTagsView: true,
  //   },
  // },
  {
    path: "/not-found",
    component: () => import("@/views/error/not-found.vue"),
    name: "NotFound",
    meta: {
      hidden: true,
      title: "Not Found",
      noTagsView: true,
    },
  },
  { path: "/:pathMatch(.*)*", redirect: "/not-found", },
]

const router = createRouter({
  history: createWebHistory(),
  strict: true,
  routes: [],
  scrollBehavior: () => ({ left: 0, top: 0, }),
},)

const { start, done, } = useNProgress()

const { loadStart, loadDone, } = usePageLoading()

const {
  // setToken,
  setGorgiasToken,
  setGorgiasCustomer,
  setGorgiasOrder,
  setGorgiasShop,
  getGorgiasToken,
} = useToken()

// const { localeState, setLocale, } = useLocale()

// const whiteList = [
//   "/home",
//   "/not-found",
//   "/redirect",
// ]

router.beforeEach(async(to,) => {
  // const userStore = useUserStore()
  // const routeStore = useRouteStore()
  start()
  loadStart()
  // await setLocale(localeState.value,)
  // checkVersionFn()
  // const { name, } = to
  const query = cloneDeep(to.query,)
  const gorgias_token = query[GORGIAS_TOKEN]
  const gorgias_order = query[GORGIAS_ORDER]
  const gorgias_customer = query[GORGIAS_CUSTOMER]
  const gorgias_shop = query[GORGIAS_SHOP]
  console.log("to.path", to.path,)
  console.log("token", gorgias_token,)
  // token
  if (gorgias_token && typeof gorgias_token === "string") {
    setGorgiasToken(gorgias_token,)
    Reflect.deleteProperty(query, GORGIAS_TOKEN,)
    return {
      path: to.path,
      query: { ...query, },
      replace: true,
    }
  }

  // order customer shop
  if (gorgias_order || gorgias_customer || gorgias_shop) {
    setGorgiasCustomer(gorgias_customer as string,)
    setGorgiasShop(gorgias_shop as string,)
    setGorgiasOrder(gorgias_order as string,)
  }

  // 没有token
  if (!getGorgiasToken() && to.path !== "/user/login") {
    console.log("token！！！！！！",)
    return {
      path: "/user/login",
      query: { ...query, },
    }
  // return "/user/login"
  }

  return true
  // const redirectPath = from.query.redirect || to.path
  // const redirect = decodeURIComponent(redirectPath as string,)
  // return to.path === redirect ? { ...to, replace: true, } : { path: redirect, }
},)

router.afterEach((to,) => {
  document.title = `${IMPORT_META_ENV.VITE_APP_TITLE} - ${useI18nTitle(to.meta,)}`
  done()
  loadDone()
},)

export function setupRouter(app: App<Element>,) {
  constantRouterMap.forEach((route,) => {
    router.addRoute(route as RouteRecordRaw,)
  },)
  app.use(router,)
}

export default router
